const $ = jQuery;
export default function EnableAriaLabelNavMegaMenu() {
	$(window).on('load', () => {
		const elements = [
			$('#et-top-navigation'), // Simple menus
			$('.et_pb_menu__wrap'), // Mega menu with sticky header
			$('.fl-mobile-pa'), //practice area menu
			$('.fl-home-practice-area'), //practice area menu
			$('.fl-mobile-practice'), //practice area menu
		];

		elements.forEach((element) => {
			if (element.length) {
				element.each(function () {
					const CurrentElement = $(this);
					const navElements = $(this).find('nav');
					const mobileMenusElements = $(this).find('.et_mobile_nav_menu, #et_mobile_nav_menu');
					if (navElements.length) {
						// If <nav> tags are present, add attributes to them
						navElements.each(function () {
							$(this).attr('aria-label', 'Main Site Navigation');
						});
					}
					if (mobileMenusElements.length) {
						mobileMenusElements.each(function () {
							$(this).attr('role', 'navigation');

							if (CurrentElement.hasClass('fl-mobile-pa') || CurrentElement.hasClass('fl-home-practice-area') || CurrentElement.hasClass('fl-mobile-practice')) {
								$(this).attr('aria-label', 'Practice Areas Navigation');
							} else {
								$(this).attr('aria-label', 'Main Site Navigation');
							}
						});
					}
				});
			}
		});
	});
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/controllers/enable_aria_label_nav_mega_menu.js